import React, { useState } from 'react';
import styles from './Timeline.module.css';

function Timeline() {
  const [expandedGroup, setExpandedGroup] = useState(null);

  const timelineGroups = [
    {
      period: "2019–2020",
      title: "Foundation & Early Development",
      milestones: [
        { year: "2019", event: "Founded in Hong Kong" },
        { year: "2020", event: "HK Science Park Incubation Program" },
        { year: "2020", event: "HKAI Lab Acceleration Program" }
      ]
    },
    {
      period: "2021–2022", 
      title: "Expansion & Recognition",
      milestones: [
        { year: "2021", event: "Won Singapore Open Innovation Platform Call 10" },
        { year: "2022", event: "Established Singapore HQ" }
      ]
    },
    {
      period: "2023–2024",
      title: "Proof of Concept & Trials",
      milestones: [
        { year: "2023", event: "SATS Baggage Optimisation Proof of Concept" },
        { year: "2024", event: "SATS Baggage Optimisation Operational Trials" }
      ]
    },
    {
      period: "2025–2026",
      title: "Launch & Future Growth",
      milestones: [
        { year: "2025", event: "Product Launch for Terminals 1-3 at Singapore Changi Airport" },
        { year: "2025", event: "Cargo Ops Trial in preparation" },
        { year: "2026", event: "Autonomous Ground Vehicles Trial at Singapore Changi Airport" }
      ]
    }
  ];

  return (
    <section className={styles.section} id="timeline">
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Our Journey</h2>
        <p className={styles.sectionSubtitle}>
          Key milestones and business impacts that have shaped our evolution in AI-driven airport solutions
        </p>
        
        <div className={styles.timeline}>
          {timelineGroups.map((group, index) => (
            <div key={index} className={styles.timelineGroup}>
              <div 
                className={styles.groupHeader}
                onClick={() => setExpandedGroup(expandedGroup === index ? null : index)}
              >
                <div className={styles.period}>{group.period}</div>
                <div className={styles.title}>{group.title}</div>
                <div className={styles.expandIcon}>
                  {expandedGroup === index ? '−' : '+'}
                </div>
              </div>
              
              {expandedGroup === index && (
                <div className={styles.milestones}>
                  {group.milestones.map((milestone, idx) => (
                    <div key={idx} className={styles.milestone}>
                      <div className={styles.year}>{milestone.year}</div>
                      <div className={styles.event}>{milestone.event}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Timeline;